import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import { EMAIL_ACTION_COPY_TO_DELETE } from '../../Email.constants'
import {
  EMAIL_PROFILE_ACTIONS_MESSAGE_ERROR_TITLE,
  EMAIL_PROFILE_ACTIONS_MESSAGE_SUCCESS_TITLE,
  useEmailProfileContext,
} from '../../Email.hooks'
import { toEmailCopyToEntityApiDataUser } from '../../EmailCopyToEntityModal'
import { EmailProfileWidgetCopiedToItemIcons } from '../EmailProfileWidgetCopiedToItemIcons'

function EmailProfileWidgetCopiedToItem({
  Component,
  value,
  onClickRemove,
  onSubmitRemove,
  ...restProps
}) {
  const { t } = useTranslation()

  const { entityData, handleReloadEntity } = useEmailProfileContext()

  const [loading, setLoading] = useState(false)

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleSubmitRemove() {
    setLoading(true)

    return onSubmitRemove({
      getPreparedData: toEmailCopyToEntityApiDataUser,
      id: value.id,
      uuid: entityData?.uuid,
    })
      .then(() => {
        handleAddSuccessNotification(
          EMAIL_PROFILE_ACTIONS_MESSAGE_SUCCESS_TITLE[
            EMAIL_ACTION_COPY_TO_DELETE
          ]
        )

        handleReloadEntity()
      })
      .catch(() => {
        handleAddErrorNotification(
          EMAIL_PROFILE_ACTIONS_MESSAGE_ERROR_TITLE[EMAIL_ACTION_COPY_TO_DELETE]
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function handleClickRemove(event) {
    stopPropagation(event)

    onClickRemove({ onSubmit: handleSubmitRemove })
  }

  return (
    <Component
      {...restProps}
      Icons={EmailProfileWidgetCopiedToItemIcons}
      disabled={loading}
      iconsProps={{
        canRemove: entityData?.permissions.can_copy_to_archive,
        loading,
        onRemove: handleClickRemove,
      }}
      tooltipAdditionalText={t('Common.ClickToOpenProfileKey')}
      value={value}
    />
  )
}

export default EmailProfileWidgetCopiedToItem
